import React from 'react';

interface ITextAboveLine {
    text: string;
}

const TextAboveLine = (props: ITextAboveLine) => {

    const { text } = props;

    return (
        <div className="w-form-text-above-line my-10 text-center">
            <p>{ text }</p>
    </div>
    )
};

export default TextAboveLine;